import { render, staticRenderFns } from "./SessionSwitchModal.vue?vue&type=template&id=0afe7ac7"
import script from "./SessionSwitchModal.vue?vue&type=script&lang=ts"
export * from "./SessionSwitchModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0afe7ac7')) {
      api.createRecord('0afe7ac7', component.options)
    } else {
      api.reload('0afe7ac7', component.options)
    }
    module.hot.accept("./SessionSwitchModal.vue?vue&type=template&id=0afe7ac7", function () {
      api.rerender('0afe7ac7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/SessionSwitchModal.vue"
export default component.exports